export default __webpack_public_path__ + "static/media/css.32dd69d4.svg";